import Vue from 'vue'
import App from './App.vue'
import Vant from 'vant';
import 'vant/lib/index.css';
import axios from 'axios'

axios.defaults.baseURL = 'http://fx.hondamaster.cn'
//axios.defaults.baseURL = 'http://localhost:5012'

Vue.use(Vant);

Vue.config.productionTip = false

new Vue({
  render: h => h(App),
}).$mount('#app')
